import React, { useEffect } from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";

import Routes from "./routes"
import Loader from "./components/ui/loader"
import Toast from "./components/ui/toast";
import { onReload } from './store/auth/actions'
import "react-toastify/dist/ReactToastify.css";

window.__DEV__ = true;

const App = (props) => {

    useEffect(() => {
        props.onReload()
    }, [])

    // SSO field officers are rendered inside the admin shell, which reserves a
    // 248px sidebar column they don't have — leaving dead space on the left.
    // Flag the body at the top level (reliable, unlike a child component's
    // effect) so the global stylesheet drops the sidebar and goes full-width.
    // Officers carry vchDesignationName in their token; internal users don't.
    const isOfficer = !!props.auth?.auth?.vchDesignationName;
    useEffect(() => {
        document.body.classList.toggle("officer-portal", isOfficer);
    }, [isOfficer]);

    return (
        <div id="wrapper">
            <Routes
                token={props.auth?.auth?.token}
                authChecked={props.auth?.authChecked}
                designation={props.auth?.auth?.vchDesignationName}
                scope={props.auth?.auth?.scope}
                districtName={props.auth?.auth?.districtName}
            />
            {props.notification.loading ? <Loader active={props.notification.loading} /> : null}
            <Toast />
        </div>
    );
}


const mapStateToProps = (state) => {
    return {
        notification: state.Notification,
        auth: state.Auth,
    }
}

// const mapDispatchToProps = { updateAdminFromLocal, getAvailableToken, onReload }

export default withRouter(connect(mapStateToProps, { onReload })(App));
